import { buildRoute, noEnvRoutes } from "@/assets/routes/routes";
import api from "../api";
import { isAxiosError } from "axios";

export const getInspectionId = async ({ id }: { id: number }) => {
  try {
    const url = buildRoute(noEnvRoutes.getInspectionById, { id });
    const { data } = await api.get(url);

    return data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getInspectionPDF = async ({ id }: { id: number }) => {
  try {
    const url = buildRoute(noEnvRoutes.getInspectionPDF, { id });
    const { data } = await api.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};
